/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast. Keeping your custom
 * Javascript in this file will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function() {
  // Add custom code below this line
  

  // Trocar texto espanhol no carrinho dinamarquês (cart drawer + /cart)
  document.addEventListener('DOMContentLoaded', () => {
    const oldText = 'ENVÍO GRATUITO - 30 DÍAS DE DEVOLUCIÓN';
    const newText = 'Gratis levering - 30 dages returret';

    function replaceText(root) {
      if (!root) return;

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      let node;

      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.includes(oldText)) {
          node.nodeValue = node.nodeValue.replace(oldText, newText);
        }
      }
    }

    // tentativa inicial
    replaceText(document.body);

    // volta a tentar quando o carrinho abre/atualiza via AJAX
    const obs = new MutationObserver(() => replaceText(document.body));
    obs.observe(document.body, { childList: true, subtree: true });
  });

  // ^^^ Keep your scripts inside this IIFE function call to avoid leaking
  // your variables into the global scope.
// FIX: trocar "ENVÍO GRATUITO - 30 DÍAS DE DEVOLUCIÓN" para dinamarquês
  document.addEventListener('DOMContentLoaded', () => {
    const replacements = [
      { from: 'ENVÍO GRATUITO - 30 DÍAS DE DEVOLUCIÓN', to: 'Gratis levering – 30 dages returret' },
      { from: 'ENVÍO GRATUITO – 30 DÍAS DE DEVOLUCIÓN', to: 'Gratis levering – 30 dages returret' }
    ];

    function run() {
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      let node;

      while ((node = walker.nextNode())) {
        if (!node.nodeValue) continue;

        for (const r of replacements) {
          if (node.nodeValue.includes(r.from)) {
            node.nodeValue = node.nodeValue.replaceAll(r.from, r.to);
          }
        }
      }
    }

    run();

    // cart drawer / ajax updates
    const obs = new MutationObserver(run);
    obs.observe(document.body, { childList: true, subtree: true });
  });
  /* ===== Corrigir texto do badge: "60% SPAR/RABAT" -> "SPAR 60%" ===== */
function fixSparBadges(root = document) {
  const nodes = root.querySelectorAll('.badge, .badge--sale, .product__badge, .product__badge--sale');
  nodes.forEach(el => {
    const t = (el.textContent || '').trim();

    // 60% SPAR  |  60% RABAT  -> SPAR 60%
    let m = t.match(/^(\d+)\s*%\s*(SAVE|RABAT)$/i);
    if (m) {
      el.textContent = `SAVE ${m[1]}%`;
      return;
    }

    // caso venha com espaços/variações: "60 % SPAR"
    m = t.match(/^(\d+)\s*%?\s*(SAVE|RABAT)$/i);
    if (m && t.includes('%')) {
      el.textContent = `SAVE ${m[1]}%`;
      return;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  fixSparBadges(document);

  // re-aplicar quando AJAX/carregamentos atualizam a página
  const obs = new MutationObserver(() => fixSparBadges(document));
  obs.observe(document.body, { childList: true, subtree: true });
});

/* ===== LEVIN / JOHN DUBLIN: "based on 7,200" a negrito ===== */
function jdBoldReviewCount(root) {
  if (!root) return;
  var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
  var targets = [];
  var node;

  while ((node = walker.nextNode())) {
    if (!node.nodeValue) continue;
    if (!/based on\s*[\d.,]+/i.test(node.nodeValue)) continue;
    if (node.parentNode && node.parentNode.classList && node.parentNode.classList.contains('jd-bold-reviews')) continue;
    targets.push(node);
  }

  targets.forEach(function (textNode) {
    var match = textNode.nodeValue.match(/based on\s*[\d.,]+/i);
    if (!match) return;

    var middle = textNode.splitText(match.index);
    middle.splitText(match[0].length);

    var strong = document.createElement('strong');
    strong.className = 'jd-bold-reviews';
    strong.style.fontWeight = '700';
    strong.textContent = middle.nodeValue;
    middle.parentNode.replaceChild(strong, middle);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  jdBoldReviewCount(document.body);
  setTimeout(function () { jdBoldReviewCount(document.body); }, 600);
  setTimeout(function () { jdBoldReviewCount(document.body); }, 1800);
});

/* ===== LEVIN / JOHN DUBLIN: titulo das avaliacoes =====
   "OVER 4,700 DELIGHTED CUSTOMERS" -> "7,200 DELIGHTED CUSTOMERS" */
function jdFixReviewsHeading(root) {
  root = root || document.body;
  if (!root) return;

  var rx = /(?:OVER\s+)?[\d.,]+(\s+DELIGHTED\s+CUSTOMERS)/i;
  var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
  var node;

  while ((node = walker.nextNode())) {
    if (!node.nodeValue) continue;
    if (!rx.test(node.nodeValue)) continue;
    node.nodeValue = node.nodeValue.replace(rx, '7,200$1');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  jdFixReviewsHeading(document.body);
  setTimeout(function () { jdFixReviewsHeading(document.body); }, 600);
  setTimeout(function () { jdFixReviewsHeading(document.body); }, 1800);
});
document.addEventListener('shopify:section:load', function () { jdFixReviewsHeading(document.body); });

/* ===== LEVIN / JOHN DUBLIN: cartao "PULLOVERS" passa a "COZY JUMPERS" ===== */
function jdRenamePulloversCard() {
  var section = document.querySelector('[id*="section_collections_list_tEe3cV"]');
  if (!section) return;

  var walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT, null);
  var node;

  while ((node = walker.nextNode())) {
    if (!node.nodeValue) continue;
    if (node.nodeValue.trim().toUpperCase() !== 'PULLOVERS') continue;
    node.nodeValue = node.nodeValue.replace(/PULLOVERS/i, 'COZY JUMPERS');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  jdRenamePulloversCard();
  setTimeout(jdRenamePulloversCard, 600);
  setTimeout(jdRenamePulloversCard, 1800);
});
document.addEventListener('shopify:section:load', jdRenamePulloversCard);

/* ===== LEVIN / JOHN DUBLIN: Size Chart nos produtos de UMA linha de tamanhos */
function jdMarkSingleRowSizes() {
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;

  var wrappers = document.querySelectorAll('.product__selectors .selector-wrapper');
  var rx = /\b(size|sizes|tamanho|tamanhos|talla|taille|grosse|grösse|größe)\b/i;
  var buttons = null;
  var i;

  for (i = 0; i < wrappers.length; i++) {
    var legend = wrappers[i].querySelector('.radio__legend__option-name') || wrappers[i].querySelector('.radio__legend');
    var txt = ((legend ? legend.textContent : '') || '').trim();
    if (!rx.test(txt)) continue;
    buttons = wrappers[i].querySelectorAll('.radio__button, .swatch__button');
    break;
  }

  if (!buttons || buttons.length === 0) return;

  var firstTop = Math.round(buttons[0].getBoundingClientRect().top);
  var oneRow = true;

  for (var j = 1; j < buttons.length; j++) {
    if (Math.abs(Math.round(buttons[j].getBoundingClientRect().top) - firstTop) > 4) {
      oneRow = false;
      break;
    }
  }

  document.body.classList.toggle('jd-sizes-one-row', oneRow);
}

document.addEventListener('DOMContentLoaded', function () {
  jdMarkSingleRowSizes();
  setTimeout(jdMarkSingleRowSizes, 500);
  setTimeout(jdMarkSingleRowSizes, 1500);
});
window.addEventListener('load', jdMarkSingleRowSizes);
window.addEventListener('resize', jdMarkSingleRowSizes);

/* ===== LEVIN / JOHN DUBLIN: menu de computador em duas linhas ===== */
function jdHeaderMenuLayout() {
  var nav = document.querySelector('.header__desktop__lower .header__menu');
  if (!nav) return;

  var kids = nav.children;
  var items = [];
  var i;

  for (i = 0; i < kids.length; i++) {
    var el = kids[i];
    if (el.classList && (el.classList.contains('hover__bar') || el.classList.contains('hover__bg') || el.classList.contains('jd-menu-break'))) continue;
    if (el.tagName === 'A' || el.querySelector('a')) items.push(el);
  }

  if (items.length === 0) return;

  // setas nos itens com sub-coleccoes
  for (i = 0; i < items.length; i++) {
    var item = items[i];
    var link = item.tagName === 'A' ? item : item.querySelector('a');
    if (!link) continue;
    if (link.querySelector('.jd-chev') || link.querySelector('svg')) continue;

    var hasSub = item.querySelector('.header__dropdown, .dropdown, .megamenu, .navdrop, ul');
    if (!hasSub && link.getAttribute('aria-haspopup') !== 'true' && item.getAttribute('aria-haspopup') !== 'true') continue;

    var chev = document.createElement('span');
    chev.className = 'jd-chev';
    chev.setAttribute('aria-hidden', 'true');
    link.appendChild(chev);
  }

  // quebra a seguir ao 8o item
  var existing = nav.querySelector('.jd-menu-break');
  if (items.length > 9) {
    if (!existing) {
      var brk = document.createElement('span');
      brk.className = 'jd-menu-break';
      nav.insertBefore(brk, items[8]);
    } else if (existing.nextElementSibling !== items[8]) {
      nav.insertBefore(existing, items[8]);
    }
  } else if (existing) {
    existing.parentNode.removeChild(existing);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  jdHeaderMenuLayout();
  setTimeout(jdHeaderMenuLayout, 400);
  setTimeout(jdHeaderMenuLayout, 1200);
});
window.addEventListener('load', jdHeaderMenuLayout);
window.addEventListener('resize', jdHeaderMenuLayout);
document.addEventListener('shopify:section:load', jdHeaderMenuLayout);

(function () {
  var CSS = [
    '@media screen and (min-width:990px){',
    '  body .header__desktop__lower{overflow:visible !important;}',
    '  body .header__desktop__lower .header__desktop__bar__c{',
    '    flex:1 1 100% !important;max-width:100% !important;width:100% !important;',
    '    overflow:visible !important;}',
    '  body .header__desktop__lower .header__menu{',
    '    display:flex !important;flex-wrap:wrap !important;',
    '    justify-content:center !important;align-items:center !important;',
    '    width:100% !important;max-width:100% !important;',
    '    row-gap:2px !important;column-gap:11px !important;',
    '    white-space:normal !important;overflow:visible !important;}',
    '  body .header__desktop__lower .header__menu > *{flex:0 0 auto !important;}',
    '  body .header__desktop .header__desktop__lower .header__menu .navlink,',
    '  body .header__desktop .header__desktop__lower .header__menu .navtext,',
    '  body .header__desktop .header__desktop__lower .header__menu a{',
    '    font-size:14px !important;font-weight:500 !important;',
    '    letter-spacing:0.04em !important;white-space:nowrap !important;}',
    '  body .theme__header{overflow:visible !important;}',
    '  body .header__menu .jd-menu-break{flex:0 0 100% !important;width:100% !important;height:0 !important;margin:0 !important;padding:0 !important;}',
    '  body .header__desktop__lower .header__menu .jd-chev{',
    '    display:inline-block;width:6px;height:6px;margin-left:6px;',
    '    border-right:1.2px solid currentColor;border-bottom:1.2px solid currentColor;',
    '    transform:rotate(45deg) translate(-1px,-2px);}',
    '}'
  ].join('\n');

  function injectCss() {
    if (document.getElementById('jd-header-menu-css')) return;
    var s = document.createElement('style');
    s.id = 'jd-header-menu-css';
    s.textContent = CSS;
    (document.body || document.documentElement).appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectCss);
  } else {
    injectCss();
  }
})();

/* ===== LEVIN / JOHN DUBLIN =====
   Carrinho lateral: tamanhos e espacamentos como estavam antes das ultimas
   experiencias. Sem letra aumentada, sem caixa de quantidades aumentada e
   sem o arranjo em coluna para telemovel. */
(function () {
  var CSS = [
    '@media screen and (min-width:750px){',
    '  body.template-product .product__form__holder{margin-bottom:0 !important;}',
    '  body.template-product .shopify-block[id*=size_chart_inline_button]{',
    '    margin-top:0 !important;margin-bottom:0 !important;',
    '    position:relative !important;z-index:6 !important;}',
    '  body.template-product .usp-list{margin-top:-20px !important;}',
    '}',
    '@media screen and (max-width:749px){',
    '  body.template-product .product__form__holder{margin-bottom:0 !important;}',
    '  body.template-product .shopify-block[id*=size_chart_inline_button]{',
    '    margin-top:-35px !important;margin-bottom:21px !important;',
    '    position:relative !important;z-index:6 !important;}',
    '  body.template-product .usp-list{margin-top:-10px !important;}',
    '  body.template-product.jd-sizes-one-row .shopify-block[id*=size_chart_inline_button]{',
    '    margin-top:0 !important;margin-bottom:0 !important;}',
    '}',
    '/* TELEMOVEL: sem espaco por cima e imagem de bordo a bordo */',
    '@media screen and (max-width:749px){',
    '  body.template-product .shopify-section:has(.product__page){padding-top:0 !important;}',
    '  body.template-product .shopify-section:has(.product__page) .section-padding{padding-top:0 !important;}',
    '  body.template-product .product__wrapper,',
    '  body.template-product .product-single{--PT:0px !important;padding-top:0 !important;}',
    '  body.template-product .product__images,',
    '  body.template-product product-images.product__images{',
    '    margin-top:0 !important;padding-top:0 !important;',
    '    width:100vw !important;max-width:100vw !important;',
    '    padding-left:0 !important;padding-right:0 !important;',
    '    margin-left:calc(50% - 50vw) !important;',
    '    margin-right:calc(50% - 50vw) !important;}',
    '  body.template-product .product__images img{width:100% !important;max-width:100% !important;}',
    '}',
    '/* DESKTOP: espaco por cima em linha com o resto da pagina */',
    '@media screen and (min-width:750px){',
    '  body.template-product .shopify-section:has(.product__page) .section-padding{padding-top:30px !important;}',
    '  body.template-product .product__wrapper,',
    '  body.template-product .product-single{--PT:30px !important;padding-top:30px !important;}',
    '  body.template-product .product__images,',
    '  body.template-product product-images.product__images{',
    '    margin-top:0 !important;padding-top:0 !important;',
    '    margin-left:-28px !important;margin-right:0 !important;',
    '    padding-left:0 !important;padding-right:0 !important;',
    '    width:auto !important;max-width:none !important;}',
    '  body.template-product .product__page{column-gap:28px !important;}',
    '}',
    '/* titulo do produto maior e mais destacado */',
    'body.template-product .product__title{',
    '  font-size:26px !important;line-height:1.22 !important;font-weight:600 !important;}',
    'body.template-product .product__head{margin-top:12px !important;}',
    'body.template-product .product__block--custom-code:has(+ .product__head),',
    'body.template-product .product__custom-code:has(+ .product__head){',
    '  font-size:14.5px !important;line-height:1.4 !important;}',
    'body.template-product .jd-bold-reviews{font-weight:700 !important;}',
    '@media screen and (max-width:749px){',
    '  body.template-product .product__title{font-size:22px !important;}',
    '  body.template-product .product__head{margin-top:9px !important;}',
    '  body.template-product .product__block--custom-code:has(+ .product__head),',
    '  body.template-product .product__custom-code:has(+ .product__head){font-size:13.5px !important;}',
    '}',
    '/* selo de desconto: cantos bicudos e verde #60B37F */',
    'body .lp-save-badge{border-radius:0 !important;background:#60B37F !important;background-color:#60B37F !important;background-image:none !important;}',
    '/* caixa das quantidades: largura total da coluna, como o Add to cart */',
    'body .jd-bulk-box{max-width:100% !important;width:100% !important;padding:13px 22px !important;}',
    'body .jd-bulk-title{font-size:15px !important;margin-bottom:8px !important;line-height:1.15 !important;}',
    'body .jd-bulk-line{font-size:13.5px !important;margin-bottom:4px !important;line-height:1.3 !important;}',
    '@media screen and (max-width:749px){',
    '  body .jd-bulk-box{padding:10px 16px !important;}',
    '  body .jd-bulk-title{font-size:13.5px !important;margin-bottom:7px !important;}',
    '  body .jd-bulk-line{font-size:12.5px !important;margin-bottom:3px !important;}',
    '}',
    '/* DESKTOP: imagem fixa, informacao a fazer scroll */',
    '@media screen and (min-width:750px){',
    '  body.template-product .index-product,',
    '  body.template-product .product__wrapper,',
    '  body.template-product .product__wrapper__inner,',
    '  body.template-product .product__page{overflow:visible !important;}',
    '  body.template-product .product__page{align-items:flex-start !important;}',
    '  body.template-product product-images.product__images,',
    '  body.template-product .product__images{',
    '    position:-webkit-sticky !important;position:sticky !important;',
    '    top:90px !important;align-self:flex-start !important;',
    '    height:auto !important;}',
    '  body.template-product .form__wrapper{',
    '    position:static !important;top:auto !important;bottom:auto !important;',
    '    transform:none !important;}',
    '}',
    '/* carta do John na pagina de produto: letra fina */',
    'body.template-product .hero__rte,',
    'body.template-product .hero__rte p,',
    'body.template-product .hero__rte span,',
    'body.template-product .hero__rte li{font-weight:300 !important;}',
    'body.template-product .hero__rte strong,',
    'body.template-product .hero__rte b{font-weight:600 !important;}',
    '/* carrinho lateral: largura no painel interior, nao na camada de fundo */',
    '@media screen and (min-width:750px){',
    '  body #cart-drawer .drawer__inner{width:470px !important;max-width:92vw !important;}',
    '}',
    '/* rodape do carrinho sempre inteiro, nunca cortado em baixo */',
    'body #cart-drawer .drawer__inner{',
    '  display:flex !important;flex-direction:column !important;',
    '  height:100% !important;max-height:100% !important;overflow:hidden !important;}',
    'body #cart-drawer .drawer__body{',
    '  flex:1 1 auto !important;min-height:0 !important;overflow-y:auto !important;}',
    'body #cart-drawer .drawer__foot{',
    '  flex:0 0 auto !important;padding-bottom:2px !important;overflow:visible !important;}',
    '/* margens laterais folgadas: nada encostado a beira */',
    'body #cart-drawer .drawer__head{padding-left:26px !important;padding-right:26px !important;}',
    'body #cart-drawer .drawer__items{padding-left:26px !important;padding-right:26px !important;}',
    'body #cart-drawer .drawer__foot{padding-left:26px !important;padding-right:26px !important;}',
    'body #cart-drawer .drawer__close{margin-right:0 !important;}',
    '/* faixa do temporizador junta ao primeiro produto */',
    'body #cart-drawer .levin-promo-banner{margin-bottom:0 !important;}',
    'body #cart-drawer .drawer__items{padding-top:0 !important;margin-top:0 !important;}',
    'body #cart-drawer .cart-block{margin-top:0 !important;padding-top:0 !important;}',
    'body #cart-drawer cart-items .cart__item:first-of-type{',
    '  padding-top:0 !important;margin-top:-6px !important;}',
    '/* caixote do lixo e precos desencostados da beira */',
    'body #cart-drawer .levin-remove-btn{right:8px !important;}',
    'body #cart-drawer .cart__price.levin-price-block{right:22px !important;}',
    'body #cart-drawer .cart__item__title{padding-right:44px !important;}',
    '/* precos todos do mesmo tamanho, riscado e final na mesma linha */',
    'body #cart-drawer .cart__price.levin-price-block{line-height:1.3 !important;}',
    'body #cart-drawer .levin-compare{',
    '  display:inline !important;font-size:13.5px !important;line-height:1.3 !important;',
    '  margin-right:7px !important;vertical-align:baseline !important;}',
    'body #cart-drawer .levin-final,',
    'body #cart-drawer .levin-final-plain{',
    '  display:inline !important;font-size:13.5px !important;line-height:1.3 !important;',
    '  vertical-align:baseline !important;}',
    'body #cart-drawer .levin-line-savings{',
    '  display:block !important;font-size:13.5px !important;line-height:1.3 !important;',
    '  margin-top:3px !important;}',
    '/* ESPACAMENTOS DO RODAPE */',
    'body #cart-drawer .levin-cart-price-wrapper{',
    '  padding-left:0 !important;padding-right:0 !important;padding-bottom:0 !important;',
    '  margin-bottom:0 !important;overflow:visible !important;}',
    'body #cart-drawer .cart__foot__inner,',
    'body #cart-drawer .cart__price__holder,',
    'body #cart-drawer .cart__form{overflow:visible !important;}',
    'body #cart-drawer .levin-cart-badges{',
    '  margin-left:-26px !important;margin-right:-26px !important;',
    '  padding-left:26px !important;padding-right:26px !important;',
    '  padding-top:10px !important;padding-bottom:10px !important;',
    '  justify-content:center !important;align-items:center !important;',
    '  max-width:none !important;box-sizing:border-box !important;}',
    'body #cart-drawer .levin-cart-badge{font-size:14.5px !important;}',
    'body #cart-drawer .levin-cart-badge svg{width:19px !important;height:19px !important;}',
    'body #cart-drawer .levin-cart-badge img.levin-carrier{height:22px !important;}',
    'body #cart-drawer .levin-cart-badge-divider{height:18px !important;}',
    'body #cart-drawer .levin-remise-row{padding:10px 0 10px !important;margin:0 !important;line-height:1.25 !important;}',
    'body #cart-drawer .levin-rabatt-badge{padding-top:3px !important;padding-bottom:3px !important;}',
    '/* botao do checkout e icones sem folga por baixo */',
    'body #cart-drawer .levin-checkout-btn,',
    'body .drawer--cart .levin-checkout-btn{',
    '  margin-top:0 !important;margin-bottom:0 !important;}',
    'body #cart-drawer .levin-payments,',
    'body .drawer--cart .levin-payments{margin-bottom:0 !important;padding-bottom:0 !important;}',
    'body #cart-drawer .cart__price__holder{margin-bottom:0 !important;padding-bottom:0 !important;}'
  ].join('\n');

  function injectCss() {
    if (document.getElementById('jd-usp-tight-css')) return;
    var s = document.createElement('style');
    s.id = 'jd-usp-tight-css';
    s.textContent = CSS;
    (document.body || document.documentElement).appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectCss);
  } else {
    injectCss();
  }
})();

})();
